"use strict";
var connections;
(function (connections) {
    var domainselector;
    (function (domainselector) {
        var Event;
        (function (Event) {
            Event[Event["DomainSelectionSuccess"] = 'DomainSelectionSuccess'] = "DomainSelectionSuccess";
        })(Event = domainselector.Event || (domainselector.Event = {}));
    })(domainselector = connections.domainselector || (connections.domainselector = {}));
})(connections || (connections = {}));

//# sourceMappingURL=connections.domainselector.enumerators.js.map
